import { render, staticRenderFns } from "./BarcodeScanner.vue?vue&type=template&id=0a9576fe&scoped=true"
import script from "./BarcodeScanner.vue?vue&type=script&lang=js"
export * from "./BarcodeScanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9576fe",
  null
  
)

export default component.exports